import ErrorBoundary from 'component/ui/ErrorBoundaries/ErrorBoundary';
import React, { useCallback } from 'react';

import ModuleLoadingFallback from '../ModuleLoadingFallback';

export interface IModuleLoadingFailed {
  children: React.ReactNode;
  filePath?: string;
  publicPath?: string;
}

/**
 * An ErrorBoundary for lazy loading failures.
 *
 * Reports to logger with error location and info about where it happened and
 * renders fallback message.
 *
 * @param children = Component wrapped by this boundary
 * @param filePath - file path the component
 * @param publicPath - the url path on which the component renders (if known)
 */
const ModuleLoadingFailed = ({
  children,
  filePath = '',
  publicPath = '',
}: IModuleLoadingFailed): JSX.Element => {
  const setScope = useCallback(
    (scope) => {
      scope.setTag('errorBoundaryType', 'ModuleLoadingFailed');
      if (publicPath) {
        scope.setTag('publicPath', publicPath);
      }
      if (filePath) {
        scope.setTag('filePath', filePath);
      }
    },
    [publicPath, filePath],
  );
  return (
    <ErrorBoundary beforeCapture={setScope} fallback={ModuleLoadingFallback}>
      {children}
    </ErrorBoundary>
  );
};

export default ModuleLoadingFailed;
